export default "__VITE_ASSET__DY2Epdmx__"